import { Gender } from '../../store/user/types'
import { ErrorResponse, RegisterSuccessResponse } from '../../types/auth'
import { callApi } from '../../utils/api'
import { endpoints } from '../config'

export enum RegisterResponseType {
  Exists = 'exists'
}

interface RegisterProps {
  firstName: string
  lastName: string
  email: string
  phone: string
  password: string
  gender: Gender
  birthday: string
  newsletter: boolean
  salonGuid: string
}

export const registerUser = async ({
  firstName,
  lastName,
  email,
  phone,
  password,
  gender,
  birthday,
  newsletter,
  salonGuid
}: RegisterProps): Promise<RegisterSuccessResponse | ErrorResponse<RegisterResponseType.Exists> | null> => {
  const response = await callApi<RegisterSuccessResponse | ErrorResponse<'exists'>>({
    path: endpoints.register,
    body: {
      vorname: firstName,
      nachname: lastName,
      email,
      telefonnummer: phone,
      passwort: password,
      geschlecht: gender,
      refSalonGuid: salonGuid,
      geburtstag: birthday,
      newsletter,
      DeviceToken: ''
    }
  })

  if (!response.data || !response.isOk) {
    return null
  }

  if ('status' in response.data && response.data.status.toLocaleLowerCase() === 'exists') {
    return {
      message: response.data.message,
      status: RegisterResponseType.Exists
    }
  }

  return response.data as RegisterSuccessResponse
}
